import { Divider, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import {
  TriggerDatasetType,
  TriggerInputDataset,
} from '@/hooks/api/datasets/trigger/useTriggerManualRun.ts';
import PreviouslyUploadedFiles from '../PreviouslyUploadedFiles/PreviouslyUploadedFiles.tsx';
import { ManualTriggerInput } from '@/types/automationSteps.ts';
import CustomLoadingOverlay from '@/components/CustomLoadingOverlay.tsx';
import StyledTextArea from '@/components/StyledInputFields/StyledTextarea.tsx';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import ManualTriggerInputHeader from './ManualTriggerInputHeader.tsx';

type props = {
  automationId: string;
  trigger: ManualTriggerInput;
  triggerDataset: TriggerInputDataset;
  setTriggerDataset: (d: TriggerInputDataset) => void;
  isLoading: boolean;
};

const HEADER_SPACING = '4px';

const TextDatasetInput = ({
  automationId,
  trigger,
  triggerDataset,
  setTriggerDataset,
  isLoading,
}: props) => {
  const [uploadNewFiles, setUploadNewFiles] = useState(true);

  useEffect(() => {
    setUploadNewFiles(triggerDataset.type !== TriggerDatasetType.Existing);
  }, [triggerDataset.type]);

  const text = 'text' in triggerDataset && triggerDataset.text ? triggerDataset.text : '';

  const name = 'name' in triggerDataset && triggerDataset.name ? triggerDataset.name : '';

  const setTextAndName = (t: string, name: string) => {
    setTriggerDataset({
      trigger_id: triggerDataset.trigger_id,
      text: t,
      type: TriggerDatasetType.Text,
      name: name,
    });
  };

  const selectedExistingDatasetId =
    'dataset_id' in triggerDataset ? triggerDataset.dataset_id : undefined;
  const setSelectedExistingDatasetId = (id: string) => {
    setTriggerDataset({
      trigger_id: triggerDataset.trigger_id,
      dataset_id: id,
      type: TriggerDatasetType.Existing,
    });
  };

  return (
    <>
      <Divider style={{ color: '#ececec', borderTopWidth: '0.5px' }} />
      <Stack gap={0}>
        <CustomLoadingOverlay visible={isLoading} />

        <ManualTriggerInputHeader
          trigger={trigger}
          actionLabel={uploadNewFiles ? 'or use previous text' : 'or enter new text'}
          onActionClick={() => setUploadNewFiles(!uploadNewFiles)}
        />
        <Stack gap={0} mt={HEADER_SPACING}>
          {uploadNewFiles && (
            <>
              <StyledTextArea
                label={undefined}
                placeholder="Enter text here..."
                size="sm"
                value={text}
                onChange={(e) => setTextAndName(e.target.value, name)}
                required={trigger.is_required}
              />
              <StyledTextInput
                label="Input Name"
                placeholder="Enter input name"
                size="sm"
                value={name}
                onChange={(e) => setTextAndName(text, e.target.value)}
                required={false} // defaults to the trigger input name
                mt={'md'}
                maxLength={128}
              />
            </>
          )}
          {!uploadNewFiles && (
            <PreviouslyUploadedFiles
              automationId={automationId}
              manualTrigger={trigger}
              selectedExistingDatasetId={selectedExistingDatasetId}
              setSelectedExistingDatasetId={setSelectedExistingDatasetId}
            />
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default TextDatasetInput;
